import React, { useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import './style.scss';
import MonthlyTab from "./monthlyTab/page";
import AnnualyTab from "./annualyTab/page";
import { useDispatch, useSelector } from "react-redux";
import { getAllPlans } from "../../data/redux/pricing/_pricingAction";
import { getStorageItem } from "../../../services/storage.service";
import { getPricingPageData } from "../../../services/cmsPage.service";
import http, { updateAuthorizationHeader } from "../../../services/http.service";

const PricingTab = () => {
  const dispatch: any = useDispatch();
  const token = getStorageItem("token");

  const { planList = [], loading } = useSelector((state: any) => state?.pricing || {});

  // Fetch authenticated plans
  useEffect(() => {
    if (token) {
      updateAuthorizationHeader();
      dispatch(getAllPlans({}));
    }
  }, [dispatch, token]);


  // Filter plans by type
  const monthlyPlans = planList.filter((plan: any) => plan.type === "monthly");
  const yearlyPlans = planList.filter((plan: any) => plan.type === "yearly");

  // Show loading state
  if (loading) {
    return <div className="text-center py-5">Loading plans...</div>;
  }

  // Show empty state if no plans
  if (!planList || planList.length === 0) {
    return <div className="text-center py-5">No pricing plans available.</div>;
  }


  return (
    <div>
      <Tab.Container id="left-tabs-example" defaultActiveKey="Monthly">
        <Row>
          <Col sm={12}>
            <div className="d-flex justify-content-center ">
              <Nav variant="pills" className="mb-5 align-items-center justify-content-center position-relative">
                <Nav.Item>
                  <Nav.Link eventKey="Monthly">Monthly billing</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Annual">Annual billing</Nav.Link>
                </Nav.Item>
                <span className="saveText">Save 15% Off</span>
              </Nav>
            </div>
          </Col>
          <Col sm={12}>
            <Tab.Content>
              <Tab.Pane eventKey="Monthly">
                <MonthlyTab plans={monthlyPlans} />
              </Tab.Pane>
              <Tab.Pane eventKey="Annual">
                <AnnualyTab plans={yearlyPlans} />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default PricingTab;
